import { NcPage } from "@noted/noted-components";
import { ReactNode } from "react";

import { Box, Flex } from "~/components/_deprecated/primitives";
import { BackToParent } from "~/components/navigation/back-to-parent";
import { useI18n } from "~/hooks/use-i18n";

export function UserPageHeader({ children, title }: { children?: ReactNode; title: string }) {
  const { t } = useI18n("admin-users");

  return (
    <NcPage.Header className="block">
      <BackToParent to={`/admin/users/`} text={t("admin-users:back_to_users")} />
      <Flex width="100%">
        <NcPage.Heading>{title}</NcPage.Heading>
        <Box mr="auto" />
        {children}
      </Flex>
    </NcPage.Header>
  );
}
